module.exports = __webpack_public_path__ + "static/media/Jewelery.728e536c.svg";